import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { ConfigService } from '../../config/config.service';
import { DateRange } from './date-range';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { DATE_FORMAT } from '../utils/dateUtils';
import { DateRangePickerTranslations } from './DateRangePickerTranslations';
import * as uuid from 'uuid';
import * as moment from 'moment';
import { DatePickerService } from '../services/date.picker.service';

@Component({
  selector: 'cc-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent implements OnInit, AfterViewInit {
  public options;
  private format = 'YYYY-MM-DD HH:mm:ss';
  private formatOutput = 'YYYY-MM-DDTHH:mm:ss';
  private dateRange: DateRange = {} as DateRange;
  private translations: DateRangePickerTranslations;
  public inputId = uuid.v4();
  public autoFocused = true;
  public utcOffset = moment().utcOffset();
  @Input() timePicker = true;
  @Input() minDate: Date = null;
  @Input() startDate: Date = new Date();
  @Input() endDate: Date = new Date();
  @Input() maxDate: Date = new Date();
  @Input() opens: string;
  @Output() selected = new EventEmitter<DateRange>();
  @ViewChild('contactsPicker', { read: ElementRef })
  contactsPicker: ElementRef;

  constructor(
    private configService: ConfigService,
    public translate: TranslateService,
    public languageService: LanguageService,
    public datePickerService: DatePickerService
  ) {
    this.autoFocused = true;
  }

ngAfterViewInit() {
  this.contactsPicker.nativeElement.click();
}

  ngOnInit() {
    this.configureDateFormat();
    this.updateTranslations();
    this.languageService.onLanguageChange.subscribe(() => {
      this.updateTranslations();
    });

    this.autoFocused = true;

    this.datePickerService.onTogglePicker.subscribe((opens) => {
      this.contactsPicker.nativeElement.click();
      if (opens.open === 'left') {
        this.contactsPicker.nativeElement.setAttribute('style', `right: 250px; top: ${opens.positionY - 10}px`);
      } else if (opens.open === 'right') {
        this.contactsPicker.nativeElement.setAttribute(
          'style',
          `left: ${opens.positionX}px; top: ${opens.positionY - 10}px`
        );
      }
    });
  }

  updateTranslations() {
    const currentLang = this.translate.currentLang || 'en';
    this.translations = {
      translatedMonths: this.configService.getValue('months')[currentLang],
      translatedRanges: this.configService.getValue('dateRanges')[currentLang],
    };
    this.options = {
      timePicker: this.timePicker,
      applyClass: 'primary',
      cancelClass: 'warn',
      opens: 'left',
      alwaysShowCalendars: true,
      showCustomRangeLabel: false,
      locale: {
        format: this.format,
        monthNames: this.translations.translatedMonths,
      },
      ranges: this.translations.translatedRanges,
      startDate: this.startDate,
      endDate: this.endDate,
      maxDate: this.maxDate,
      minDate: this.minDate,
    };
  }

  configureDateFormat() {
    if (!this.timePicker) {
      this.format = DATE_FORMAT;
      this.formatOutput = DATE_FORMAT;
    }
  }

  selectedDate(value) {
    this.dateRange.dateFrom = moment(value.start.format(this.formatOutput));
    this.dateRange.dateTo = moment(value.end.format(this.formatOutput));
    this.selected.next(this.dateRange);

    this.datePickerService.toggleDatePicker(false);
    this.autoFocused = true;
  }

  exitPicker($event) {
    if (
      $event.target.className === 'datepicker-background' ||
      $event.target.className === 'cancelBtn btn btn-sm warn'
    ) {
      this.datePickerService.toggleDatePicker({ open: 'right', show: false });
    }
  }
}
